import { render, staticRenderFns } from "./EditTaskModal.vue?vue&type=template&id=38c76c2d&scoped=true&"
import script from "./EditTaskModal.vue?vue&type=script&lang=js&"
export * from "./EditTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c76c2d",
  null
  
)

export default component.exports